import React, { useState, useEffect } from "react";
import { getData } from "../../../../functions/request";
import {
  formatDateHourToBR,
  saveData,
} from "../../../../functions/functionsUtility";
import DescriptionPeriodValue from "../../../../layout/descriptions/DescriptionPeriodValue";
import { dateMask } from "../../../../functions/utils";
const dayjs = require("dayjs");

export default function IntergraosTrigoCme() {
  const [cotacoesData, setCotacoesData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getData("trigo_cme", "getLastTrigoCme", "insertTrigoCme")
      .then((data) => {
        setCotacoesData(data);
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setHasError(err?.message ?? "Ocorreu um erro.");
        console.log(err);
      });
  }, []);

  const [date, setDate] = useState({
    month: "",
    year: dayjs().year().toString(),
  });
  const onChange = (value, type) => {
    if (type === "month") {
      setDate((prevState) => ({ ...prevState, month: value }));
    } else if (type === "year") {
      setDate((prevState) => ({ ...prevState, year: value }));
    }
  };

  useEffect(() => {
    setCotacoesData((prevState) => ({
      ...prevState,
      cot_periodo: dayjs(`01/${date.month}/${date.year}`, "DD/MM/YYYY").format(
        "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
      ),
    }));
  }, [date]);

  return (
    <>
      <DescriptionPeriodValue
        title={"Intergrãos - Trigo - Alterando Mercado Futuro"}
        onClickButton={() => saveData(cotacoesData)}
        date={formatDateHourToBR(cotacoesData.cot_data)}
        datePickerValue={date.year}
        datePickerOnChange={onChange}
        // inputValue={cotacoesData["cot_valor"]}
        state={cotacoesData}
        setState={setCotacoesData}
        stateKey={"cot_valor"}
        isLoading={isLoading}
        hasError={hasError}
      />
    </>
  );
}
